import { Trans } from '@lingui/react/macro';

import Stack from '@/design_system/Stack';
import Paragraph from '@/design_system/Typography/Paragraph';
import IconAddToList from '@/icons/AddToList.svg';
import { DefectTypeFromGetMany } from '@/models/defectType';
import { useDatabaseTranslation } from '@/services/i18n';

export const DefectTypeDropdownItem = ({ defect }: { defect: DefectTypeFromGetMany }) => {
  const { _db } = useDatabaseTranslation();

  return (
    <Stack row style={{ flex: 1 }}>
      <Paragraph align="start">{_db(defect.name)}</Paragraph>
    </Stack>
  );
};

export const CustomDefectDropdownItem = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <Stack row gap="0.5rem" alignItems="center" style={{ flex: 1, ...style }}>
      <IconAddToList style={{ fontSize: '1.25rem' }} />
      <Paragraph>
        <Trans id="defect-type-search-select.add-custom-defect">Add a custom defect</Trans>
      </Paragraph>
    </Stack>
  );
};
